{
  "nl": {
    "task_assignment": {
      "actions": {
        "confirm": "Markeer als afgerond",
        "create": "Taak",
        "move_to_draft": "Naar concept",
        "reopen": "Heropenen",
        "send_and_notify": "Versturen en informeren"
      },
      "assignee_types": {
        "customer": "Klant",
        "employee": "Medewerker",
        "partner": "Partner"
      },
      "attributes": {
        "assignee": "Toegewezene",
        "assignees": "Toegewezenen",
        "created_at": "Aangemaakt",
        "due_date": "Vervaldatum",
        "project": "Project",
        "status": "Status",
        "task": "Taak",
        "unit": "Eenheid"
      },
      "confirm": {
        "affected": "Dit raakt {customers} en {team}.",
        "affected_customers": "Dit raakt {customers}.",
        "affected_team": "Dit raakt {team}.",
        "complete_body": "Hun taken worden voor hen afgesloten en verdwijnen uit hun lijst, ook als ze niets hebben gedaan.",
        "complete_header": "Deze taak voor iedereen afsluiten?",
        "customer_tasks": "{count} klanttaak | {count} klanttaken",
        "draft_body": "De taak verdwijnt tot ze opnieuw wordt verstuurd. E-mails die al zijn verstuurd, blijven verstuurd.",
        "draft_header": "Deze taak terugzetten naar concept?",
        "send_customers": "Klanten zien de taak meteen in hun portaal en krijgen een melding.",
        "send_header": "Naar de toegewezen personen sturen?",
        "send_permanent": "Versturen kan niet ongedaan worden gemaakt. De taak later terugzetten naar concept haalt de melding niet terug.",
        "send_status": "Ze komen op Gevraagd te staan.",
        "send_team": "Teamleden krijgen een melding.",
        "team_tasks": "{count} teamtaak | {count} teamtaken"
      },
      "labels": {
        "add_assignee": "Toegewezene toevoegen…",
        "add_customers": "Klanten toevoegen",
        "already_assigned": "Deze taak is al toegevoegd aan deze eenheid.",
        "already_assigned_project": "Deze taak is al toegevoegd aan dit project.",
        "completed": "Afgerond",
        "confirm_message": "Weet je zeker dat je deze taak als afgerond wilt markeren?",
        "customers": "Klanten",
        "my_tasks": "Mijn taken",
        "no_assignees": "Nog geen toegewezenen.",
        "no_assignments": "Nog geen taken.",
        "no_assignments_task": "Nog geen toewijzingen voor deze taak.",
        "no_assignments_unit": "Nog geen taken voor deze eenheid.",
        "required": "Dit veld is verplicht",
        "select_task": "Selecteer een taak",
        "upload_hint": "Upload het gevraagde document of de gevraagde documenten om deze taak te voltooien.",
        "uploaded_documents": "Geüploade documenten"
      },
      "statuses": {
        "completed": "Afgerond",
        "draft": "Concept",
        "requested": "Gevraagd"
      },
      "toasts": {
        "completed": "Taak afgerond",
        "create": "Taak aangemaakt",
        "delete": "Taak verwijderd",
        "reopened": "Taak heropend",
        "update": "Taak bijgewerkt"
      }
    }
  }
}
